import { Controller } from "@hotwired/stimulus";

// Surfaces browser online/offline transitions as toasts, per Material's
// offline-states guidance: tell the user connectivity changed, non-blocking,
// via the existing toast channel rather than a dedicated banner.
export default class extends Controller {
  static values = { i18nOffline: String, i18nOnlineRestored: String };

  #dismissOffline = null;

  connect() {
    this.goOffline = this.goOffline.bind(this);
    this.goOnline = this.goOnline.bind(this);
    window.addEventListener("offline", this.goOffline);
    window.addEventListener("online", this.goOnline);

    if (!navigator.onLine) this.goOffline();
  }

  disconnect() {
    window.removeEventListener("offline", this.goOffline);
    window.removeEventListener("online", this.goOnline);
  }

  goOffline() {
    this.#dismissOffline = window.showToast({
      message: this.i18nOfflineValue,
      type: "warning",
    });
  }

  goOnline() {
    this.#dismissOffline?.();
    this.#dismissOffline = null;
    window.showToast({
      message: this.i18nOnlineRestoredValue,
      type: "success",
      duration: 3000,
    });
  }
}
